import React from "react";
import "./SettingsNewFriendMainbox.css";

function FriendMainbox() {
  return <div className="settingsnewfriendmainbox"></div>;
}

export default FriendMainbox;
